import { Outlet } from "react-router-dom";
import Sidebar from "../../admin/components/Sidebar";
import Header from "../../admin/components/Header";

const AdminLayout = () => {
  return (
    <div className="App">
      <Sidebar />
      <div className="main-content">
        <Header />
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;
